/**
 * Turn a camelCase string to a hyphened one
 * @param camelString
 * @returns hypened string
 */
export function camel2hyphen(camelString: string): string {
  return camelString
    .replace(/[A-Z]/g, (match) => {
      return '-' + match.toLowerCase()
    })
    .toLowerCase()
}

/**
 * @param feature a camelCased property
 * @returns does it reference width or height?
 */
export function isDimension(feature: string): boolean {
  const re = /[height|width]$/
  return re.test(feature)
}

/**
 * Does the string is easily parsable as a number?
 * (enterprise bundle has "none" as its price)
 */
export function isNumberString(potentialNumber: string): boolean {
  const isNumber = parseInt(potentialNumber)
  return !Number.isNaN(isNumber)
}

/**
 * Lowercase string's first character
 * @param string to lowercase the first character of
 * @returns a new, lowercased string
 */
export function lowerCaseFirstCharacter(string: string): string {
  if (!string) return string
  return string.charAt(0).toLowerCase() + string.slice(1)
}

/**
 * Uppercase string's first character
 * @param string to uppercase the first character of
 * @returns a new, uppercased string
 */
export function upperCaseFirstCharacter(string: string): string {
  if (!string) return string
  return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 * Remove all spaces in the string.
 * @param string string to remove spaces from
 * @returns same string, but with no spaces
 */
export function removeSpaces(someString: string): string {
  return someString.replace(/\s/g, '')
}
/**
 * Used to properly format component props in case px amount is passed as number
 * @param numberOrString
 * @return surelyAString
 */
export function addPostfixIfNumber(
  numberOrString: number | string,
  postfix: string = 'px',
): string {
  // is it missing?
  if (!numberOrString && numberOrString !== 0) return postfix

  // is it a number?
  const isANumber = typeof numberOrString === 'number'
  if (isANumber) {
    return numberOrString + postfix
  } else {
    // is it a string?
    return numberOrString.toString()
  }
}

export function isEmailValid(email: string): boolean {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

/**
 * Utiltity: Break s3 (or any URI, really) down on slashes, return the last part
 * @param path s3 path
 * @returns the path's after the final slash or path itself
 */
export function getFileNameFromPath(path: string): string {
  if (!path) return path
  const LEVELS = path.split('/')
  return LEVELS[LEVELS.length - 1] // last element or whole, if no slash
}

/**
 * Utility to translate strings from snake_case to camelCase
 * @param input a (snake_cased) string
 * @returns a camelCased one
 */
export function snake2Camel(input: string | any): string {
  // If there are no dashes / underscores, return early
  if (!/[_-]/.test(input)) return input

  // find all the sequesnces with dash/underscore followed by a latter or a number,
  // then transform - uppercase the letter, delete the dashes / underscores
  return input
    .toLowerCase()
    .replace(/([-_][a-z0-9])/g, (group: string) =>
      group.toUpperCase().replace('-', '').replace('_', ''),
    )
}
